export const NordVPNStatusEnum = {
    NOT_REGISTERED: 'not_registered',
    PENDING: 'pending',
    ACTIVE: 'active',
    INACTIVE: 'inactive',
};
